import db from '@klinx/utils/localstorage';
const state = {
  funcType: 'main',
  devGroup: '',
  mainfunc: '',
  progId: '',
  dropsData: '',
  bMainIndex: '',
  areaB: '',
  stepInfo: [],
  devIds: '',
  pgIds: '',
  alldevs: '',
  proInfo: '',
  progName: '',
  progCode: '',
  rightStatus: '',
  groups: '',
  isCopied: 'no',
  marklineStep: '',
  clickedPara: '',
  sns: false,
  changed: 'no',
  curGroupIndex: null,
  clickedPos: '',
  stepCount: [],
  steps: 0,
  programInfo: '',
  viewModel: db.get('WEB_VIEWMODEL', 'normalView', 'String'), // 视图模型
  version: db.get('WEB_VERSION', 'new', 'String'),
  order: false
};

const mutations = {
  SET_FUNCTYPE: (state, ft) => {
    state.funcType = ft;
  },
  SET_DEVGROUP: (state, dg) => {
    state.devGroup = dg;
  },
  SET_MAINFUNC: (state, dt) => {
    state.mainfunc = dt;
  },
  SET_PROG: (state, pg) => {
    state.progId = pg;
  },
  SET_DROPS: (state, dt) => {
    state.dropsData = dt;
  },
  SET_BMAININDEX: (state, dt) => {
    state.bMainIndex = dt;
  },
  SET_B: (state, dt) => {
    state.areaB = dt;
  },
  SET_STEPINFO: (state, dt) => {
    state.stepInfo = dt;
  },
  SET_DEVIDS: (state, dt) => {
    state.devIds = dt;
  },
  SET_PGIDS: (state, dt) => {
    state.pgIds = dt;
  },
  SET_ALLDEVS: (state, dt) => {
    state.alldevs = dt;
  },
  SET_PROINFO: (state, dt) => {
    state.proInfo = dt;
  },
  SET_PROGNAME: (state, name) => {
    state.progName = name;
  },
  SET_PROGCODE: (state, code) => {
    state.progCode = code;
  },
  SET_RSTATUS: (state, st) => {
    state.rightStatus = st;
  },
  SET_GROUPS: (state, dt) => {
    state.groups = dt;
  },
  SET_COPIED: (state, dt) => {
    state.isCopied = dt;
  },
  SET_MARKLINESTEP: (state, dt) => {
    state.marklineStep = dt;
  },
  SET_CLICKEDPARA: (state, dt) => {
    state.clickedPara = dt;
  },
  SET_SNS: (state, dt) => {
    state.sns = dt;
  },
  SET_CHANGED: (state, dt) => {
    state.changed = dt;
  },
  SET_CURGROUPINDEX: (state, dt) => {
    state.curGroupIndex = dt;
  },
  SET_CLICKEDPOS: (state, dt) => {
    state.clickedPos = dt;
  },
  SET_STEPCOUNT: (state, dt) => {
    state.stepCount = dt;
  },
  SET_STEPS: (state, dt) => {
    state.steps = dt;
  },
  SET_PROGRAMINFO: (state, dt) => {
    state.programInfo = dt;
  },
  SET_VIEWMODEL: (state, dt) => {
    state.viewModel = dt;
    db.save('WEB_VIEWMODEL', dt || 'normalView', 'String');
  },
  SET_VERSION: (state, dt) => {
    state.version = dt;
    db.save('WEB_VERSION', dt, 'String');
  },
  SET_ORDER: (state, dt) => {
    state.order = dt;
  }
};

const actions = {
  markdownFuncType({ commit }, ft) {
    commit('SET_FUNCTYPE', ft);
  },
  markdownDevGroup({ commit }, dg) {
    commit('SET_DEVGROUP', dg);
  },
  markdownProg({ commit }, progId) {
    commit('SET_PROG', progId);
  },
  markdownMainFunction({ commit }, dt) {
    commit('SET_MAINFUNC', dt);
  },
  markdownDropsData({ commit }, dt) {
    commit('SET_DROPS', dt);
  },
  markdownBmainIndex({ commit }, dt) {
    commit('SET_BMAININDEX', dt);
  },
  markdownB({ commit }, dt) {
    commit('SET_B', dt);
  },
  markdownStepInfo({ commit }, dt) {
    commit('SET_STEPINFO', dt);
  },
  markdownDevIds({ commit }, dt) {
    commit('SET_DEVIDS', dt);
  },
  markdownPgIds({ commit }, dt) {
    commit('SET_PGIDS', dt);
  },
  markdownAllDevs({ commit }, dt) {
    commit('SET_ALLDEVS', dt);
  },
  markdownProInfo({ commit }, dt) {
    commit('SET_PROINFO', dt);
  },
  markdownProgName({ commit }, n) {
    commit('SET_PROGNAME', n);
  },
  markdownProgCode({ commit }, n) {
    commit('SET_PROGCODE', n);
  },
  markdownStepCount({ commit }, n) {
    commit('SET_STEPCOUNT', n);
  },
  markdownSteps({ commit }, n) {
    commit('SET_STEPCOUNT', n);
  },
  markdownRightStatus({ commit }, st) {
    commit('SET_RSTATUS', st);
  },
  markdownGroups({ commit }, dt) {
    commit('SET_GROUPS', dt);
  },
  markdownCopied({ commit }, dt) {
    commit('SET_MARKLINESTEP', dt);
  },
  markdownMarklineStep({ commit }, dt) {
    commit('SET_COPIED', dt);
  },
  markdownClickedPara({ commit }, dt) {
    commit('SET_CLICKEDPARA', dt);
  },
  markdownSpanNShrink({ commit }, dt) {
    commit('SET_SNS', dt);
  },
  markdownChanged({ commit }, dt) {
    commit('SET_CHANGED', dt);
  },
  markdownCurGroupIndex({ commit }, dt) {
    commit('SET_CURGROUPINDEX', dt);
  },
  markdownClickedPos({ commit }, dt) {
    commit('SET_CLICKEDPOS', dt);
  },
  markdownProgramInfo({ commit }, dt) {
    commit('SET_PROGRAMINFO', dt);
  },
  markdownViewModel({ commit }, dt) {
    commit('SET_VIEWMODEL', dt);
  },
  markdownVersion({ commit }, dt) {
    commit('SET_VERSION', dt);
  },
  markdownOrderModel({ commit }, dt) {
    commit('SET_ORDER', dt);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
